import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import RateReviewIcon from '@mui/icons-material/RateReview';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import Dashboard from '../components/Dashboard';

const navItems = [
  { label: 'Review Queue', icon: <RateReviewIcon /> },
  { label: 'Statistics', icon: <BarChartIcon /> },
  { label: 'Interns', icon: <PeopleIcon /> },
  { label: 'Settings', icon: <SettingsIcon /> },
];

function ExpertDashboard() {
  return (
    <Dashboard title="Expert Review" navItems={navItems}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Expert Review Portal
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Review submitted assessments and approve reports.
      </Typography>

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={4}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Pending Review
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#f59e0b' }}>
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Approved This Week
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#16a34a' }}>
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Total Reviewed
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e3a8a' }}>
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Review Queue */}
      <Paper variant="outlined" sx={{ p: 3, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Review Queue
          </Typography>
          <Chip label="0 pending" size="small" color="warning" />
        </Box>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary">
            No assessments pending review. Check back later.
          </Typography>
        </Box>
      </Paper>

      {/* Review Statistics */}
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Review Statistics
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                --
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Avg Review Time
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                --
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Approval Rate
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                --
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Avg Assessment Score
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                --
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Active Interns
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Dashboard>
  );
}

export default ExpertDashboard;
